import { render, staticRenderFns } from "./IPDropTest.vue?vue&type=template&id=1e6aae90&"
import script from "./IPDropTest.vue?vue&type=script&lang=js&"
export * from "./IPDropTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports